import { BiChangeSetDetail } from '@euler/model/bi/change-set';
import { useEffect } from 'react';
import { useBiDashboardHost } from '../BiDashboardHostContext';

/**
 * Draws a pending change set over its dashboard while the chat is open on
 * that dashboard, until it is settled; the newest proposal is on top.
 */
export function useBiGhost(detail: BiChangeSetDetail | null, show: boolean) {
  const host = useBiDashboardHost();
  const changeSet = detail?.changeSet;
  const preview = detail?.preview;
  const onHost = !!host && host.dashboardId === changeSet?.dashboardId;
  useEffect(() => {
    if (!host || !onHost || !show || !changeSet || !preview) return;
    return host.showGhost({
      changeSetId: changeSet.id,
      createdAt: changeSet.createdAt,
      baseRevision: changeSet.baseRevision,
      summary: changeSet.summary,
      preview,
    });
  }, [host, onHost, show, changeSet, preview]);
  return onHost;
}
